import React, { FC }                                                                                                             from 'react';
import * as Yup                                                                                                                  from "yup";
import { BulkUpdateFormControlContainer }                                                                                        from "@src/views/pages/projects/activities/bulk/BulkUpdateFormControlContainer";
import { TextAreaField }                                                                                                         from "@src/views/components/forms";
import { StaticProjectActivityBulkUpdateShell, StaticProjectActivityBulkUpdateShellFormContainerProps, StaticProjectActivityBulkUpdateShellProps } from "@src/views/pages/projects/activities/bulk/StaticProjectActivityBulkUpdateShell";
import { ProjectActivityBulkUpdateMultiDialogProps }                                                                             from "@src/views/pages/projects/operations/StaticProjectActivityBulkUpdateMultiDialog";


type FormTypeAttributes = {
    notes: string | null
}

const formDefaultValues = {
    notes: ''
}

const validationSchema = (
    Yup.object().shape( {
        notes: Yup.string().nullable(),
    } )
)

const mutationAttributeFormatter: StaticProjectActivityBulkUpdateShellProps<FormTypeAttributes>['prepareFormValuesForMutation'] = ( values ) => {
    return {
        notes: ( `${ values.notes }` ).trim(),
    }
}

interface StaticProjectActivityBulkUpdateNotesProps
    extends Pick<StaticProjectActivityBulkUpdateShellProps<FormTypeAttributes>, 'supportModals' | 'supportToasts'>,
        Pick<ProjectActivityBulkUpdateMultiDialogProps, 'projectId' | 'projectVersionId' | 'projectActivityIds'> {
    formContainer: FC<StaticProjectActivityBulkUpdateShellFormContainerProps>
}

const StaticProjectActivityBulkUpdateNotesDefaultProps = {
    supportModals: false,
    supportToasts: true,
} satisfies Partial<StaticProjectActivityBulkUpdateNotesProps>

function StaticProjectActivityBulkUpdateNotes( _props: StaticProjectActivityBulkUpdateNotesProps ){

    const props = { ...StaticProjectActivityBulkUpdateNotesDefaultProps, ..._props };

    return (

        <StaticProjectActivityBulkUpdateShell<FormTypeAttributes>
            projectId={ props.projectId }
            projectVersionId={ props.projectVersionId }
            ids={ props.projectActivityIds }
            supportToasts={ props.supportToasts }
            supportModals={ props.supportModals }
            defaultFormValues={ formDefaultValues }
            validationSchema={ validationSchema }
            formContainer={ props.formContainer }
            prepareFormValuesForMutation={ mutationAttributeFormatter }>

            {/* FORM CONTENT */ }
            { ( { formik, isProcessing, isLoading } ) => (

                <BulkUpdateFormControlContainer
                    icon={ 'pencil' }
                    title={ 'Update Notes' }
                    description={ 'Migrate notes for multiple activities to the one specified. All notes will be overwritten.' }>

                    <TextAreaField
                        label={ 'Notes' }
                        descriptionText={ 'Apply notes to the selected activities.' }
                        name={ `notes` }
                        rows={ 8 }
                        disabled={ isLoading || isProcessing }
                    />

                </BulkUpdateFormControlContainer>

            ) }

        </StaticProjectActivityBulkUpdateShell>

    );
}

export {
    StaticProjectActivityBulkUpdateNotes,
    StaticProjectActivityBulkUpdateNotesDefaultProps,
    type StaticProjectActivityBulkUpdateNotesProps,
};
